import { REPLY_LOG_INPUT_MESSAGE } from '../../constants/reply-log'

import api from '../../libs/api'
/**
 * Actions for performing the reply
 */
export const REPLY_LOG_REQUEST = 'TICKETS/REPLY_LOG/REQUEST'
export const REPLY_LOG_SUCCESS = 'TICKETS/REPLY_LOG/SUCCESS'
export const REPLY_LOG_FAILURE = 'TICKETS/REPLY_LOG/FAILURE'
export const RESET_LOG_REPLY = 'TICKETS/REPLY_LOG/RESET'

const replyLogRequest = () => ({
  type: REPLY_LOG_REQUEST,
})

const replyLogSuccess = () => {
  return {
    type: REPLY_LOG_SUCCESS,
  }
}
const replyLogFailure = error => ({
  type: REPLY_LOG_FAILURE,
  payload: error instanceof Error ? error : new Error(error),
  error: true,
})

export const replyLog = (id, message) => dispatch => {
  dispatch(replyLogRequest())

  return api
    .postReplyLog(id, message)
    .then(res => res.json())
    .then(
      response => {
        if (response.status === 200) {
          return dispatch(replyLogSuccess())
        } else {
          return dispatch(replyLogFailure(response.reason))
        }
      },
      () => dispatch(replyLogFailure('An error occurred while logging you in'))
    )
}

/**
 * Actions related to keyboard on reply screen
 */
export const FOCUS_LOG_INPUT = 'REPLY_LOG/FOCUS_INPUT'
export const UPDATE_LOG_INPUT = 'REPLY_LOG/UPDATE_INPUT'
export const DELETE_LOG_INPUT = 'REPLY_LOG/DELETE_INPUT'
export const ERROR_LOG_INPUT = 'REPLY_LOG/ERROR_INPUT'
export const SET_LOG_STATUS = 'REPLY_LOG/SET_STATUS'
export const FOCUS_LOG_KEYBOARD = 'REPLY_LOG/FOCUS_KEYBOARD'

export const focusLogInput = (focusedInput, focusedRow, focusedCol) => {
  let newFocusedInput
  switch (focusedInput) {
    case REPLY_LOG_INPUT_MESSAGE:
      newFocusedInput = focusedInput
      break
    default:
      newFocusedInput = REPLY_LOG_INPUT_MESSAGE
  }

  return {
    type: FOCUS_LOG_INPUT,
    payload: {
      focusedInput: newFocusedInput,
      focusedRow: focusedRow,
      focusedCol: focusedCol,
    },
  }
}

export const updateLogInput = newKey => ({
  type: UPDATE_LOG_INPUT,
  payload: {
    newKey,
  },
})

export const deleteLogInput = () => ({
  type: DELETE_LOG_INPUT,
})

export const errorLogInput = (input, error) => ({
  type: ERROR_LOG_INPUT,
  payload: {
    input,
    error,
  },
})

export const setLogStatus = status => ({
  type: SET_LOG_STATUS,
  payload: {
    status,
  },
})

export const focusLogKeyboard = focus => ({
  type: FOCUS_LOG_KEYBOARD,
  payload: {
    focus,
  },
})
